import { Button } from 'antd';

import { constants } from 'helpers/constants';
import { EProductStatus } from 'helpers/enums';
import type IProduct from 'interfaces/IProduct';
import { CHECKOUT_ELEMENTS_URL } from 'settings';
import { EModerationStatus } from 'v2/interfaces/product';

import { Icon } from '@eduzz/ui-antd-theme';

interface IProps {
  selectedProduct: IProduct;
}

function isPhysicalPendingModeration(product: IProduct): boolean {
  return product.type === constants.PHYSICAL && product.moderation_status === EModerationStatus.PENDING;
}

function hasCheckout(product: IProduct): boolean {
  if (!product?.id) {
    return false;
  }

  if (product.isMainWithChildren()) {
    return false;
  }

  if (product.active === EProductStatus.DRAFT) {
    return false;
  }

  return !isPhysicalPendingModeration(product);
}

const AccessCheckoutButton = ({ selectedProduct }: IProps) => {
  if (!CHECKOUT_ELEMENTS_URL || !hasCheckout(selectedProduct)) {
    return null;
  }

  const checkoutUrl = `${CHECKOUT_ELEMENTS_URL}/${selectedProduct.hash || selectedProduct.id}`;

  return (
    <Button
      icon={<Icon.ExternalLink />}
      href={checkoutUrl}
      target='_blank'
      rel='noopener noreferrer'
      className='max-md:w-full'
    >
      Acessar checkout
    </Button>
  );
};

export default AccessCheckoutButton;
